<template>
  <div v-if="dialogVisible" class="notice-dialog">
    <div class="notice-dialog-title">
      <div class="title">
        🎉🎉🎉 升级改版通知
      </div>
      <div class="close" @click="dialogVisible = false">
        <i class="el-icon-close" />
      </div>
    </div>
    <div class="notice-dialog-content">
      <p>
        我们非常高兴地通知您，我们系统即将进行全新UI改版，新UI界面将帮助您更高效地处理您的业务，并且获得更好的使用体验。
      </p>
      <p>该功能升级即将上线。我们非常期待您的体验，并欢迎您的反馈与建议。如果您在使用过程中有任何问题，请随时联系我们。</p>
      <p>再次感谢您对我们系统的支持，祝您使用愉快！</p>
      <p class="text-right">
        货主端系统团队
      </p>
    </div>
    <div class="notice-dialog-footer">
      <a-button type="primary" @click="handleViewNew">
        新版尝鲜
      </a-button>
      <a-button @click="dialogVisible = false">
        我知道了
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment';
import env from '../../env/index';

export default {
  name: 'NoticeDialog',
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed:{
    ...mapGetters('iframe', ['isHiddenMenu']),
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    if(this.isHiddenMenu || window.__POWERED_BY_WUJIE__) {
      return;
    }
    const nowTimeStap = moment().format('x')
    const newVersionNoticeTime = localStorage.getItem("newVersionNoticeTime")
    if(!newVersionNoticeTime) {
      this.dialogVisible = true
      localStorage.setItem("newVersionNoticeTime", nowTimeStap);
      // this.$store.commit('setting/setNewVersionNoticeTime', nowTimeStap)
      return
    }
    if(nowTimeStap > moment(Number(newVersionNoticeTime)).add(3, 'hours').format('x') ){
      this.dialogVisible = true
      localStorage.setItem("newVersionNoticeTime", nowTimeStap);
      // this.$store.commit('setting/setNewVersionNoticeTime', nowTimeStap)
    }else {
      this.dialogVisible = false
    }
  },
  methods: {
    handleViewNew() {
      window.open(env.NEW_SYSTEM_URL);
    },
  },
};
</script>

<style lang="less" scoped>
.notice-dialog {
  position: fixed;
  width: 480px;
  min-height: 274px;
  box-sizing: border-box;
  right: 16px;
  top: 60px;
  z-index: 3000;
  padding: 20px 24px;
  background: #FFFFFF;
  border: 1px solid #E6EAF0;
  box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.05), 0px 8px 10px 1px rgba(0, 0, 0, 0.06), 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  .notice-dialog-title {
    margin-bottom: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 16px;
      line-height: 24px;
      color: #1C2026;
      font-weight: 600;
    }
    .close {
      color: #7E8694;
      cursor: pointer;
      height: 16px;
      display: flex;
      align-items: center;
      &:hover {
        font-weight: 600;
        color: #1C2026;
      }
      .el-icon-close {
        font-size: 16px;
      }
    }
  }
  .notice-dialog-content {
    margin-bottom: 12px;
    width: 100%;
    p {
      color: #505762;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
    }
    .text-right {
      text-align: right;
    }
  }
  .notice-dialog-footer {
    padding: 0 24px;
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}
</style>
